export default __webpack_public_path__ + "static/8_36-3d481e8f3fb1ddefa469cc8cbbb4d555.png";